import entityHexMapData from '../../../../data/giv/geocoding/entity-hex-map.json';
const data = entityHexMapData;
/**
 * Get the entity mapping for a country by its ISO A2 code.
 * Throws if the country code is not in the map (fail loudly).
 */
export const getCountryMapping = (countryCode) => {
    const index = data.countriesByCode[countryCode];
    if (index === undefined) {
        throw new Error(`No entity hex mapping for country: ${countryCode}. ` +
            `Available: ${Object.keys(data.countriesByCode).join(', ')}`);
    }
    return data.entities[index];
};
/** True if the country (ISO A2) has an entity hex mapping — lets callers skip rather than throw. */
export const hasCountryMapping = (countryCode) => data.countriesByCode[countryCode] !== undefined;
/**
 * Get an entity mapping by its ID (country code, ocean id, or region id).
 * Returns undefined if not found.
 */
export const getEntityMapping = (entityId) => data.entities.find((e) => e.id === entityId);
/**
 * Get all entity mappings.
 */
export const getAllEntityMappings = () => data.entities;
/**
 * Get the full entity hex map metadata.
 */
export const getEntityHexMap = () => data;
// --- Reverse lookup: res-2 H3 cell → entity name ---
let reverseMap;
/** Build a map from every res-2 cell in the entity-hex-map to its entity name. */
const buildReverseMap = () => {
    const map = new Map();
    for (const entity of data.entities) {
        // Skip the global "Planet Earth" entry — its cells overlap everything
        if (entity.type === 'planet')
            continue;
        for (const cell of entity.cells) {
            // Prefer country over ocean/region if there's overlap
            if (!map.has(cell) || entity.type === 'country') {
                map.set(cell, entity.name);
            }
        }
    }
    return map;
};
/**
 * Resolve an H3 cell (any resolution) to its containing entity name
 * (country, ocean, or region). Returns undefined if the cell falls outside
 * all mapped entities.
 *
 * Uses `cellToParent(hex, 2)` to coarsen to the entity-hex-map resolution,
 * then looks up in a lazily-built reverse index.
 */
export const resolveHexToLocationName = (hexId, cellToParent) => {
    if (!reverseMap) {
        reverseMap = buildReverseMap();
    }
    const res2Ancestor = cellToParent(hexId, 2);
    return reverseMap.get(res2Ancestor);
};
//# sourceMappingURL=entity-hex-map.js.map